import { useEffect, useRef, type ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'

/** Onderaan op de telefoon, in het midden vanaf 700px. Esc en tik op de sluier sluiten. */
export function Lade({ titel, open, sluit, kinderen, breed, klasse }: {
  titel: string; open: boolean; sluit: () => void; kinderen: ReactNode; breed?: boolean; klasse?: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!open) return
    const k = (e: KeyboardEvent) => { if (e.key === 'Escape') sluit() }
    document.addEventListener('keydown', k)
    const vorige = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    ref.current?.focus()
    return () => { document.removeEventListener('keydown', k); document.body.style.overflow = vorige }
  }, [open, sluit])
  if (!open) return null
  return createPortal(
    <div className="sluier" onClick={(e) => { if (e.target === e.currentTarget) sluit() }}>
      <div ref={ref} tabIndex={-1} role="dialog" aria-modal="true" aria-label={titel}
        className={`lade ${breed ? 'breed' : ''} ${klasse ?? ''}`}>
        <div className="lade-greep" />
        <div className="lade-kop">
          <h2>{titel}</h2>
          <button className="knop stil-knop rond" onClick={sluit} aria-label="Sluiten"><X size={22} /></button>
        </div>
        {kinderen}
      </div>
    </div>,
    document.body,
  )
}
